import { get } from "lodash";
import { SOURCE_STATUSES } from "utils/constants/sourceStatus";

export const isSelectableOfferTracer = (tracer) => {
  const sourceId = get(tracer, "source.id");
  if (!sourceId) return true;
  return get(tracer, "source.status") === SOURCE_STATUSES.ACTIVE;
};

export const selectableOfferTracers = (tracers = []) =>
  tracers.filter(isSelectableOfferTracer);
